const blogData = {
    "status": "success",
    "data": {
        "blogs": [
            {
                "id": 1,
                "title": "How to Start a Successful Blog",
                "author": "Jane Doe",
                "date": "2024-10-09",
                "summary": "Learn the essential steps to starting a successful blog, from choosing the right niche to promoting your content.",
                "content": "Blogging has become one of the most popular ways to share your thoughts, ideas, and expertise. Here's how to start: 1. Choose your niche. 2. Set up your platform. 3. Write high-quality content. 4. Promote your blog. Continue reading to dive deeper into each step...",
                "image_url": "https://picsum.photos/seed/blog1/600/400",
                "more_details": "https://lorem.blog/how-to-start-a-successful-blog"
            },
            {
                "id": 2,
                "title": "SEO Tips for Beginners",
                "author": "John Smith",
                "date": "2024-09-28",
                "summary": "Understanding SEO is key to driving traffic to your blog. Learn the best tips and tricks for beginners.",
                "content": "Search Engine Optimization (SEO) helps your blog rank higher in search results. Here are some beginner-friendly tips: 1. Focus on keywords. 2. Optimize meta descriptions. 3. Improve your site speed. 4. Use internal and external links. Discover more details by following the full guide...",
                "image_url": "https://picsum.photos/seed/blog2/600/400",
                "more_details": "https://lorem.blog/seo-tips-for-beginners"
            },
            {
                "id": 3,
                "title": "10 Content Ideas to Keep Your Blog Fresh",
                "author": "Alice Walker",
                "date": "2024-10-09",
                "summary": "Running out of content ideas? Here are 10 creative blog post ideas to keep your audience engaged.",
                "content": "Staying consistent with your blog posts can be challenging. Here are 10 ideas to inspire your next post: 1. How-to guides. 2. Case studies. 3. Personal stories. 4. Listicles. 5. Product reviews. Click 'More Details' to read about the remaining ideas and how to implement them...",
                "image_url": "https://picsum.photos/seed/blog3/600/400",
                "more_details": "https://lorem.blog/10-content-ideas-to-keep-your-blog-fresh"
            },
            {
                "id": 4,
                "title": "The Importance of Mobile-Friendly Websites",
                "author": "Tom Lee",
                "date": "2024-10-1",
                "summary": "More people browse the internet on mobile devices than ever before. Is your blog mobile-friendly?",
                "content": "With the rise of mobile internet usage, it's crucial to ensure your blog is optimized for mobile. Here's why it matters: 1. Better user experience. 2. Improved SEO rankings. 3. Increased engagement. Learn how to optimize your site for mobile by clicking 'More Details'...",
                "image_url": "https://picsum.photos/seed/blog4/600/400",
                "more_details": "https://lorem.blog/the-importance-of-mobile-friendly-websites"
            },
            {
                "id": 5,
                "title": "Building a Loyal Blog Audience",
                "author": "Sarah Green",
                "date": "2024-08-18",
                "summary": "A loyal audience is the backbone of any successful blog. Here’s how you can build and retain one.",
                "content": "Attracting readers is one thing, but keeping them is another. To build a loyal audience: 1. Be consistent. 2. Engage with your readers. 3. Offer valuable content. 4. Build a community. For more insights on how to grow a dedicated following, click 'More Details'...",
                "image_url": "https://picsum.photos/seed/blog5/600/400",
                "more_details": "https://lorem.blog/building-a-loyal-blog-audience"
            },
            {
                "id": 6,
                "title": "How to Monetize Your Blog",
                "author": "Emma Carter",
                "date": "2024-08-05",
                "summary": "Looking to turn your blog into a source of income? Here are the best strategies to monetize your blog.",
                "content": "Monetizing your blog can be a rewarding process. Here are some of the most effective ways: 1. Affiliate marketing. 2. Sponsored posts. 3. Digital products. 4. Ads. Explore the full details on how to start making money from your blog...",
                "image_url": "https://picsum.photos/seed/blog6/600/400",
                "more_details": "https://lorem.blog/how-to-monetize-your-blog"
            },
            {
                "id": 7,
                "title": "The Benefits of Guest Blogging",
                "author": "Michael Brown",
                "date": "2024-10-10",
                "summary": "Guest blogging is a great way to reach a wider audience and build relationships with other bloggers.",
                "content": "Guest blogging can open doors to new opportunities and increase your visibility. The benefits include: 1. Building backlinks. 2. Expanding your network. 3. Gaining new followers. To learn more about the advantages and how to get started, click 'More Details'...",
                "image_url": "https://picsum.photos/seed/blog7/600/400",
                "more_details": "https://lorem.blog/the-benefits-of-guest-blogging"
            },
            {
                "id": 8,
                "title": "The Power of Visual Content in Blogging",
                "author": "Rachel White",
                "date": "2024-07-10",
                "summary": "Visual content is a must for modern blogs. Learn how images, infographics, and videos can enhance your blog.",
                "content": "Incorporating visuals into your blog posts can drastically improve engagement. Here's how: 1. Use high-quality images. 2. Create infographics. 3. Add videos. Dive deeper into how to effectively use visuals in your blog by clicking 'More Details'...",
                "image_url": "https://picsum.photos/seed/blog8/600/400",
                "more_details": "https://lorem.blog/the-power-of-visual-content-in-blogging"
            },
            {
                "id": 9,
                "title": "Blogging Tools Every Blogger Should Know",
                "author": "David King",
                "date": "2024-06-28",
                "summary": "These essential blogging tools will help streamline your workflow and improve your blog’s performance.",
                "content": "Having the right tools can make all the difference in your blogging journey. Some must-have tools include: 1. Grammarly for editing. 2. Canva for visuals. 3. Google Analytics for insights. Discover more about these and other tools in the full post...",
                "image_url": "https://picsum.photos/seed/blog9/600/400",
                "more_details": "https://lorem.blog/blogging-tools-every-blogger-should-know"
            },
            {
                "id": 10,
                "title": "How to Write Engaging Blog Posts",
                "author": "Sophia Martinez",
                "date": "2024-06-12",
                "summary": "Writing engaging blog posts is key to keeping your readers coming back. Here are some tips to help.",
                "content": "To create blog posts that captivate your audience: 1. Write a compelling headline. 2. Use a conversational tone. 3. Keep paragraphs short. 4. Add visuals and links. Explore more tips and strategies by reading the full guide...",
                "image_url": "https://picsum.photos/seed/blog10/600/400",
                "more_details": "https://lorem.blog/how-to-write-engaging-blog-posts"
            },
            {
                "id": 11,
                "title": "Creating a Blogging Schedule",
                "author": "Emily Johnson",
                "date": "2024-06-05",
                "summary": "A blogging schedule can help you stay organized and consistent. Here’s how to create one.",
                "content": "Planning your blog posts in advance can save time and keep your content organized. Here are steps to create a blogging schedule: 1. Set specific days for writing. 2. Plan content themes. 3. Use a calendar or digital tool. For more tips, click 'More Details'...",
                "image_url": "https://picsum.photos/seed/blog11/600/400",
                "more_details": "https://lorem.blog/creating-a-blogging-schedule"
            },
            {
                "id": 12,
                "title": "How to Use Social Media to Promote Your Blog",
                "author": "Liam Taylor",
                "date": "2024-05-25",
                "summary": "Social media can be a powerful tool for driving traffic to your blog. Here’s how to use it effectively.",
                "content": "To promote your blog on social media, consider these strategies: 1. Share your posts regularly. 2. Engage with your audience. 3. Join relevant groups. 4. Use analytics to track performance. For detailed tips, follow the link for more information...",
                "image_url": "https://picsum.photos/seed/blog12/600/400",
                "more_details": "https://lorem.blog/how-to-use-social-media-to-promote-your-blog"
            },
            {
                "id": 13,
                "title": "Crafting the Perfect Blog Post Title",
                "author": "Olivia Harris",
                "date": "2024-05-10",
                "summary": "Your blog post title is the first thing readers see. Here’s how to make it captivating.",
                "content": "A great title can entice readers to click and read your post. Here are tips for crafting effective titles: 1. Keep it short and sweet. 2. Use power words. 3. Include numbers if applicable. For a deeper dive, click 'More Details'...",
                "image_url": "https://picsum.photos/seed/blog13/600/400",
                "more_details": "https://lorem.blog/crafting-the-perfect-blog-post-title"
              },
              {
                "id": 14,
                "title": "Understanding Your Audience",
                "author": "Noah Lewis",
                "date": "2024-04-30",
                "summary": "Knowing your audience is key to creating content that resonates. Here are ways to understand them better.",
                "content": "To create content that your audience loves, follow these tips: 1. Analyze your blog’s analytics. 2. Conduct surveys. 3. Engage in comments and social media. Click 'More Details' for more strategies on audience understanding...",
                "image_url": "https://picsum.photos/seed/blog14/600/400",
                "more_details": "https://lorem.blog/understanding-your-audience"
              },
              {
                "id": 15,
                "title": "Tips for Writing Effective Blog Introductions",
                "author": "Emma Wilson",
                "date": "2024-04-20",
                "summary": "Your blog introduction sets the tone. Here are tips for writing effective introductions.",
                "content": "An engaging introduction can hook your readers. Here are some tips: 1. Start with a question or quote. 2. State a fact or statistic. 3. Preview what the reader will learn. Click 'More Details' for further insights...",
                "image_url": "https://picsum.photos/seed/blog15/600/400",
                "more_details": "https://lorem.blog/tips-for-writing-effective-blog-introductions"
              },
              {
                "id": 16,
                "title": "How to Repurpose Blog Content",
                "author": "James Scott",
                "date": "2024-04-10",
                "summary": "Repurposing content can save time and reach new audiences. Here’s how to do it effectively.",
                "content": "Repurposing your blog content can give it new life. Here are ways to repurpose: 1. Turn blog posts into videos. 2. Create infographics from data. 3. Compile posts into an eBook. Learn more strategies by clicking 'More Details'...",
                "image_url": "https://picsum.photos/seed/blog16/600/400",
                "more_details": "https://lorem.blog/how-to-repurpose-blog-content"
              },
              {
                "id": 17,
                "title": "Blogging Mistakes to Avoid",
                "author": "Sophia Clark",
                "date": "2024-03-30",
                "summary": "Avoiding common blogging mistakes can improve your success. Here are the top mistakes to steer clear of.",
                "content": "Every blogger makes mistakes, but avoiding common ones can lead to better results. Here are mistakes to avoid: 1. Ignoring SEO. 2. Inconsistent posting. 3. Neglecting audience engagement. For a full list, click 'More Details'...",
                "image_url": "https://picsum.photos/seed/blog17/600/400",
                "more_details": "https://lorem.blog/blogging-mistakes-to-avoid"
              },
              {
                "id": 18,
                "title": "The Role of Analytics in Blogging",
                "author": "Ethan Young",
                "date": "2024-03-20",
                "summary": "Analytics can provide valuable insights into your blog's performance. Here’s how to use them.",
                "content": "Understanding your blog's analytics is crucial for growth. Here are key metrics to track: 1. Page views. 2. Bounce rate. 3. Average time on page. Click 'More Details' to learn how to analyze your blog data effectively...",
                "image_url": "https://picsum.photos/seed/blog18/600/400",
                "more_details": "https://lorem.blog/the-role-of-analytics-in-blogging"
              },
              {
                "id": 19,
                "title": "Effective Call-to-Actions for Your Blog",
                "author": "Charlotte Ramirez",
                "date": "2024-03-10",
                "summary": "A strong call-to-action (CTA) can boost engagement. Here’s how to create effective CTAs.",
                "content": "Crafting effective CTAs can increase conversions. Here are tips: 1. Be clear and concise. 2. Create urgency. 3. Make it visually appealing. Learn more about CTAs by clicking 'More Details'...",
                "image_url": "https://picsum.photos/seed/blog19/600/400",
                "more_details": "https://lorem.blog/effective-call-to-actions-for-your-blog"
              },
              {
                "id": 20,
                "title": "The Evolution of Blogging",
                "author": "William Baker",
                "date": "2024-02-28",
                "summary": "Blogging has changed significantly over the years. Here’s a look at its evolution.",
                "content": "From personal journals to professional platforms, blogging has evolved. Explore key milestones and changes in blogging: 1. Early blogging platforms. 2. Rise of social media integration. 3. The future of blogging. Click 'More Details' for an in-depth exploration...",
                "image_url": "https://picsum.photos/seed/blog20/600/400",
                "more_details": "https://lorem.blog/the-evolution-of-blogging"
              }
        ]
    }
}

export default blogData;
